import { useEffect } from 'react'

import BtnGrid from '@App/components/BtnGrid/BtnGrid'
import IconBtnHor from '@App/components/IconBtnHor/IconBtnHor'

function TypeSelect(props) {
  const {
    value,
    onChange,
    types,
    iconBasePath = '/img/icons',
    useColor = false,
  } = props

  useEffect(() => {
    if (types) {
      onChange(types && types[0]?.id)
    }
  }, [types, onChange])

  if (!types || types.length === 0) {
    return null
  }

  return (
    <BtnGrid>
      {types.map(({ id, label, icon, color }) => {
        const iconPath = icon ? `${iconBasePath}/${icon}.svg` : undefined

        return (
          <IconBtnHor
            key={id}
            iconProps={iconPath ? { icon: iconPath, size: '22px', css: useColor ? { svg: { fill: color } } : undefined } : undefined}
            inactive={value !== id}
            onClick={() => onChange(id)}
          >
            {label}
          </IconBtnHor>
        )
      })}
    </BtnGrid>
  )
}

export default TypeSelect
